module.exports = __webpack_public_path__ + "img/8e2f553a3d279b76ce7f12495c4ab150.png";